// @flow weak
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {UserActions} from '../reducers/user/index'
import _ from 'lodash'

import {
    Col, Tab, Icon, Image,
    FormGroup, InputGroup,
    FormControl, PanelContainer,
    Button, Grid, Row, HelpBlock,
    PanelBody, Panel, 
} from '@sketchpixy/rubix'
import {
    APP_ADMIN_ROLE,
    ERROR_MESSAGES,
    FIELD_STATUSES, isValidEmail
} from '../utils'
import NotificationSystem from 'react-notification-system'
import generatePassword from '../utils/generateRandomPassword.mjs'
import LoadingContainer from "../components/LoadingContainer";
import {DEFAULT_USER_IMAGE} from "../utils/index";
import { prop } from 'ramda'

class AdminProfile extends Component {
    constructor(props) {
        super(props)

        let {entityId} = props
        console.log("entityId 1: ", props)
        if(!entityId) {
            entityId = props.match.params.id
        }
        const editable = props.history && props.history.location && props.history.location.editable ? props.history.location.editable : props.editable
        const appAdminRole = localStorage.getItem("role")
        this.state = {
            isUpdating: false,
            entityId,
            id: 0,
            userRole: '',
            imagePreviewUrl: '',
            userImage: null,
            showPassword: false,
            userFirstName: '',
            firstNameError: {
                status: null,
                message: ''
            },
            userLastName: '',
            lastNameError: {
                status: null,
                message: ''
            },
            userEmail: '',
            emailError: {
                status: null,
                message: ''
            },
            password: '',
            newPassword: '',
            confirmNewPassword: '',
            passwordError: {
                status: null,
                message: ''
            },
            newPasswordError: {
                status: null,
                message: ''
            },
            confirmPasswordError: {
                status: null,
                message: ''
            },

            isEditable: editable,
            appAdminRole: appAdminRole,
            isChangePassword: false,
            updateRequest: false
        }
    }

    componentDidMount() {
        const {entityId = 0} = this.state
        this.props.getUserInfo({id: entityId})
        this._notificationSystem = this.refs.notificationSystem
    }

    componentWillReceiveProps(newProps) {
        let {userInfo: newPropsUserDetails = {}, error = undefined, passwordError} = newProps
        let {userInfo: existingPropsUserDetails = {}} = this.props
        const {isUpdating, isEditable, isChangePassword} = this.state;

        console.log(error)
        console.log(passwordError)
        if (error) {
            this._addNotification(`Profile:`, error, 'error')
        } else if (passwordError) {
            this._addNotification(`Password :`, passwordError, 'error')
        } else if (newProps && newProps.isUserUpdate && isUpdating && isEditable) {
            this._addNotification(`Profile:`, `updated successfully`, 'success')
            this.toggleEditInfo(false)
        } else if (newProps && newProps.isPasswordUpdated && isUpdating && isChangePassword) {
            this._addNotification(`Password :`, `updated successfully`, 'success')
            this.toggleChangePassword(false)
        }

        if (!_.isEqual(newPropsUserDetails, existingPropsUserDetails)) {
            const {name: {first: userFirstName = '', last: userLastName = ''} = {}, id, email: userEmail, role: userRole, picture} = newPropsUserDetails

            this.setState({
                imagePreviewUrl: picture && picture.url ? picture.url : '',
                userFirstName,
                userLastName,
                userEmail,
                userRole,
                isUpdating: false,
                id
            })
        }
    }

    handleFieldValidations = () => {
        const {
            userFirstName, userLastName,
            userEmail, password, confirmNewPassword, newPassword, isChangePassword
        } = this.state
        let [firstNameError, lastNameError, emailError, passwordError, newPasswordError, confirmPasswordError, errorExist] = [{}, {}, {}, {}, {}, {}, false]
        if (!userFirstName || userFirstName.trim().length === 0) {
            firstNameError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.FIRST_NAME_ERROR_MESSAGE}
            errorExist = true
        }

        if (!userLastName || userLastName.trim().length === 0) {
            lastNameError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.LAST_NAME_ERROR_MESSAGE}
            errorExist = true
        }

        // if (password && password.length < 6) {
        //   passwordError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.PASSWORD_LENGTH_ERROR_MESSAGE}
        //   errorExist = true
        // }

        if (!userEmail || userEmail.trim().length === 0) {
            emailError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.EMAIL_REQUIRED_ERROR}
            errorExist = true
        } else if (!isValidEmail(userEmail)) {
            emailError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.EMAIL_PATTERN_ERROR}
            errorExist = true
        }

        if (isChangePassword) {
            if (!password) {
                passwordError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.PASSWORD_ERROR_MESSAGE}
                errorExist = true
            }

            if (!newPassword) {
                newPasswordError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.PASSWORD_ERROR_MESSAGE}
                errorExist = true
            }


            if (!confirmNewPassword) {
                confirmPasswordError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.PASSWORD_ERROR_MESSAGE}
                errorExist = true
            }

            //confirmPasswordError

            if (password && password.length < 5) {
                passwordError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.PASSWORD_LENGTH_ERROR_MESSAGE}
                errorExist = true
            }

            if (newPassword && newPassword.length < 5) {
                newPasswordError = {status: FIELD_STATUSES.ERROR, message: ERROR_MESSAGES.PASSWORD_LENGTH_ERROR_MESSAGE}
                errorExist = true
            }


            if (confirmNewPassword && confirmNewPassword.length < 5) {
                confirmPasswordError = {
                    status: FIELD_STATUSES.ERROR,
                    message: ERROR_MESSAGES.PASSWORD_LENGTH_ERROR_MESSAGE
                }
                errorExist = true
            }

            if (newPassword && confirmNewPassword && !_.isEqual(newPassword, confirmNewPassword)) {
                confirmPasswordError = {
                    status: FIELD_STATUSES.ERROR,
                    message: ERROR_MESSAGES.COMPARE_NEW_PASSWORD_MISMATCH
                }
                errorExist = true
            }
        }

        return {
            firstNameError,
            lastNameError,
            emailError,
            passwordError,
            newPasswordError,
            confirmPasswordError,
            errorExist
        }
    }

    _addNotification = (title, message, level) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title,
            level,
            autoDismiss: 4,
            position: 'br'
        })
    }

    generateRandomPassword = () => {
        const password = generatePassword({
            length: 8,
            numbers: true
        })

        this.setState({
            newPassword: password,
            newPasswordError: {
                status: null,
                message: ''
            }
        })
    }

    handleChangeInput = ({target: {name, value}}) => {
        this.setState({
            [name]: value,
            firstNameError: {
                status: null,
                message: ''
            },
            lastNameError: {
                status: null,
                message: ''
            },
            emailError: {
                status: null,
                message: ''
            },
            passwordError: {
                status: null,
                message: ''
            },
            newPasswordError: {
                status: null,
                message: ''
            },
            confirmPasswordError: {
                status: null,
                message: ''
            },
        })
    }

    updateUserInfo = () => {
        const {firstNameError, lastNameError, emailError, errorExist} = this.handleFieldValidations()
        if (errorExist) {
            this._addNotification('Fields Error', 'Please fill all fields to continue', 'error')
            this.setState({
                firstNameError, lastNameError, emailError
            })
            return
        }
        const {userFirstName = null, userLastName = null, id, userEmail, userImage = undefined} = this.state

        if (userFirstName && userLastName && id && userEmail) {
            this.setState({
                isUpdating: true
            }, () => {
                const name = {
                    first: userFirstName,
                    last: userLastName
                };

                this.props.updateUserInfo(id, name, userEmail, userImage)
            })
        }
    }

    updateUserPassword = () => {
        const {passwordError, emailError, newPasswordError, confirmPasswordError, errorExist} = this.handleFieldValidations()
        if (errorExist) {
            this._addNotification('Fields Error', 'Please fill all fields to continue', 'error')
            this.setState({
                emailError,
                passwordError,
                newPasswordError,
                confirmPasswordError
            })
            return
        }
        const {password = undefined, newPassword = undefined} = this.state

        if (password && newPassword) {
            this.setState({
                isUpdating: true
            }, () => {
                this.props.updatePassword(password, newPassword)
            })
        }
    }

    toggleEditInfo = (isEditable) => {
        this.setState({
            password: '',
            newPassword: '',
            confirmNewPassword: '',
            isEditable,
            isChangePassword: false
        })
    }

    toggleChangePassword = (isChangePassword) => {
        this.setState({
            password: '',
            newPassword: '',
            confirmNewPassword: '',
            isChangePassword,
            isEditable: false
        })
    }

    onProfileChange = (e) => {
        const {target: {files}} = e;

        let reader = new FileReader();
        let file = files[0];

        reader.onloadend = () => {
            this.setState({
                userImage: file,
                imagePreviewUrl: reader.result
            });
        }

        reader.readAsDataURL(file)
    };

    showHidePassword = () => {
        const {showPassword} = this.state
        this.setState({
            showPassword: !showPassword
        })
    }

    // TODO is this needed?
    backToUserList = () => {
        const {history} = this.props
        history.push('/admin/profile')
    }

    render() {
        let {
            userInfo: user = {}, updating = false,
            fetching = false, profile = false
        } = this.props
        const {
            userFirstName = '', userLastName = '', userRole = '',
            userEmail = '', password = '', newPassword = '', confirmNewPassword = '', isEditable = false, isChangePassword = false,
            firstNameError, lastNameError, emailError,
            passwordError, showPassword, newPasswordError,
            imagePreviewUrl, confirmPasswordError,
            appAdminRole
        } = this.state
        let roleToShow = userRole === APP_ADMIN_ROLE? "Admin": "Doctor"
        return (

            <PanelContainer className='inbox' collapseBottom>
                <Panel>
                    <PanelBody
                        style={{paddingTop: 0}}>
                        <div className='full-page '>
                            <Grid>
                                <Row>
                                    <Col xs={12} style={{paddingTop: 12.5}}>
                                        {
                                            // !profile || isEditable || isChangePassword ?
                                            //     <h3>
                                            //         <Button
                                            //             outlined inverse
                                            //             type='submit'
                                            //             bsStyle='primary'
                                            //             className='pull-right btn-back'
                                            //             onClick={isEditable || isChangePassword ? this.toggleEditInfo.bind(this, false) : this.backToUserList.bind(this)}
                                            //             style={{marginBottom: 5, position: 'absolute'}}>
                                            //             {/* <Icon glyph='icon-fontello-angle-circled-left'
                                            //                   className='back-icon'/> */}
                                            //             Back
                                            //         </Button>
                                            //     </h3>
                                            //     : null
                                        }

                                        <div className="profile-img-container">
                                            <Image
                                                className="display-image-user-driver"
                                                src={imagePreviewUrl ? imagePreviewUrl : DEFAULT_USER_IMAGE}/>

                                            {isEditable && <label htmlFor="file-input" className="image-upload-label">
                                                <span className='icon-fontello-camera rubix-icon camera-rubix-icon'/>
                                            </label>}

                                            <div style={{display: 'none'}}>
                                                <input type="file" id="file-input" name="file"
                                                       onChange={this.onProfileChange} accept="image/*"
                                                       multiple={false}/>
                                            </div>

                                        </div>
                                        <h3 className='text-center'>
                                            {user && user.fullName ? `${user.fullName}` : null}
                                        </h3>
                                    </Col>
                                </Row>
                            </Grid>
                            <hr style={{margin: 0}}/>
                            <NotificationSystem ref='notificationSystem'/>
                            {(fetching || updating) && <LoadingContainer />}
                            {
                                user && Object.keys(user).length ? <Panel horizontal>
                                    <PanelBody className='panel-sm-9 panel-xs-12' style={{paddingTop: 0}}>
                                        <Grid>
                                            <Col xs={12}>
                                                <Tab.Pane eventKey={user}>

                                                    {
                                                        !isChangePassword ? <Col
                                                            xs={12}>
                                                            {
                                                                isEditable ? <Row style={{marginTop: 15}}>
                                                                    <Col xs={3}>
                                                                        First
                                                                        Name
                                                                    </Col>
                                                                    <Col xs={9}>
                                                                        <FormGroup
                                                                            validationState={firstNameError.status}>
                                                                            <InputGroup>
                                                                                <InputGroup.Addon>
                                                                                    <Icon
                                                                                        glyph='icon-fontello-user'/>
                                                                                </InputGroup.Addon>
                                                                                <FormControl
                                                                                    type='text'
                                                                                    id='formGroupInputLarge'
                                                                                    name='userFirstName'
                                                                                    placeholder='Enter your first name'
                                                                                    onChange={this.handleChangeInput}
                                                                                    value={userFirstName}/>
                                                                            </InputGroup>
                                                                            <strong><HelpBlock>{firstNameError.message}</HelpBlock></strong>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row> : null}
                                                            {
                                                                isEditable ?
                                                                    <hr style={{margin: 0, marginBottom: 15}}/> : null}
                                                            {
                                                                isEditable ? <Row>
                                                                    <Col xs={3}>
                                                                        Last
                                                                        Name
                                                                    </Col>
                                                                    <Col xs={9}>
                                                                        <FormGroup
                                                                            validationState={lastNameError.status}>
                                                                            <InputGroup>
                                                                                <InputGroup.Addon>
                                                                                    <Icon
                                                                                        glyph='icon-fontello-user'/>
                                                                                </InputGroup.Addon>
                                                                                <FormControl
                                                                                    type='text'
                                                                                    id='formGroupInputLarge'
                                                                                    name='userLastName'
                                                                                    placeholder='Enter your last name'
                                                                                    onChange={this.handleChangeInput}
                                                                                    value={userLastName}/>
                                                                            </InputGroup>
                                                                            <strong><HelpBlock>{lastNameError.message}</HelpBlock></strong>
                                                                        </FormGroup>

                                                                    </Col>
                                                                </Row> : null}
                                                            {
                                                                isEditable ?
                                                                    <hr style={{margin: 0, marginBottom: 15}}/> : null}
                                                            <Row style={ isEditable ? {} : {marginTop: 15}}>
                                                                <Col xs={3}>
                                                                    Email
                                                                </Col>
                                                                <Col xs={9}>
                                                                    { isEditable && appAdminRole===APP_ADMIN_ROLE?
                                                                        <FormGroup validationState={emailError.status}>
                                                                            <InputGroup>
                                                                                <InputGroup.Addon>
                                                                                    <Icon
                                                                                        glyph='icon-fontello-email'/>
                                                                                </InputGroup.Addon>
                                                                                <FormControl
                                                                                    type='text'
                                                                                    id='formGroupInputLarge'
                                                                                    name="userEmail"
                                                                                    placeholder='Enter your email'
                                                                                    onChange={this.handleChangeInput}
                                                                                    value={userEmail}/>
                                                                            </InputGroup>
                                                                            <strong><HelpBlock>{emailError.message}</HelpBlock></strong>
                                                                        </FormGroup>
                                                                        :
                                                                        <strong>{userEmail}</strong>}
                                                                </Col>
                                                            </Row>
                                                            {
                                                                !isEditable
                                                                && <hr style={{margin: 0, marginBottom: 15}}/>}
                                                            {
                                                                !isEditable
                                                                && <Row>
                                                                    <Col xs={3}>
                                                                        Role
                                                                    </Col>
                                                                    <Col xs={9}>
                                                                        <strong>{roleToShow}</strong>
                                                                    </Col>
                                                                </Row>}
                                                            {
                                                                !isEditable
                                                                && <hr style={{margin: 0, marginBottom: 15}}/>}
                                                            
                                                            {
                                                                !isEditable && <Row>
                                                                    <Col xs={3}>
                                                                        Password
                                                                    </Col>
                                                                    <Col xs={9}>
                                                                        <Button
                                                                            outlined
                                                                            type='button'
                                                                            style={{marginBottom: 5}}
                                                                            onClick={this.toggleChangePassword.bind(this, true)}>
                                                                            Change password
                                                                        </Button>
                                                                    </Col>
                                                                </Row>}
                                                            <hr style={{margin: 0, marginBottom: 15}}/>
                                                        </Col> : ''}

                                                    {
                                                        !isEditable && isChangePassword ? <Col
                                                            xs={12}>
                                                            <Row style={{marginTop: 15}}>
                                                                <Col xs={3}>Old Password</Col>
                                                                <Col xs={9}>
                                                                    <FormGroup
                                                                        validationState={passwordError.status}>
                                                                        <InputGroup>
                                                                            <InputGroup.Addon>
                                                                                {/* <Icon glyph='icon-fontello-key'/> */}
                                                                            </InputGroup.Addon>
                                                                            <FormControl
                                                                                type={showPassword ? 'text' : 'password'}
                                                                                id='formGroupInputLarge'
                                                                                name='password'
                                                                                onChange={this.handleChangeInput}
                                                                                className='border-focus-blue text-field-modal'
                                                                                value={password}
                                                                                placeholder='Enter old password'/>
                                                                        </InputGroup>
                                                                        <strong><HelpBlock>{passwordError.message}</HelpBlock></strong>
                                                                    </FormGroup>
                                                                </Col>
                                                                <hr style={{margin: 0, marginBottom: 15}}/>
                                                            </Row>
                                                            {/* <hr style={{margin: 0, marginBottom: 15}}/> */}
                                                            <Row>
                                                                <Col xs={3}>New Password</Col>
                                                                <Col xs={9}>
                                                                    <FormGroup
                                                                        validationState={newPasswordError.status}>
                                                                        <InputGroup>
                                                                            <InputGroup.Addon>
                                                                                {/* <Icon glyph='icon-fontello-key'/> */}
                                                                            </InputGroup.Addon>
                                                                            <FormControl
                                                                                type={showPassword ? 'text' : 'password'}
                                                                                id='formGroupInputLarge'
                                                                                name='newPassword'
                                                                                onChange={this.handleChangeInput}
                                                                                className='border-focus-blue text-field-modal'
                                                                                value={newPassword}
                                                                                placeholder='Enter new password'/>
                                                                        </InputGroup>
                                                                        <strong><HelpBlock>{newPasswordError.message}</HelpBlock></strong>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            {/* <hr style={{margin: 0, marginBottom: 15}}/> */}
                                                            <Row>
                                                                <Col xs={3}>Set New Password</Col>
                                                                <Col xs={9}>
                                                                    <FormGroup
                                                                        validationState={confirmPasswordError.status}>
                                                                        <InputGroup>
                                                                            <InputGroup.Addon>

                                                                                {/* <Icon glyph='icon-fontello-key'/> */}
                                                                            </InputGroup.Addon>
                                                                            <FormControl
                                                                                type={showPassword ? 'text' : 'password'}
                                                                                id='formGroupInputLarge'
                                                                                name='confirmNewPassword'
                                                                                onChange={this.handleChangeInput}
                                                                                className='border-focus-blue text-field-modal'
                                                                                value={confirmNewPassword}
                                                                                placeholder='Confirm new password'/>
                                                                        </InputGroup>
                                                                        <strong><HelpBlock>{confirmPasswordError.message}</HelpBlock></strong>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            {/* <hr style={{margin: 0, marginBottom: 15}}/> */}
                                                        </Col>
                                                            : null
                                                    }

                                                    <Col
                                                        xs={12}>
                                                        <div
                                                            className='text-center'>
                                                            {
                                                                isEditable
                                                                    ? <Button
                                                                    type='submit'
                                                                    bsStyle='primary'
                                                                    style={{marginBottom: 15}}
                                                                    onClick={this.updateUserInfo}>
                                                                    Save
                                                                </Button>
                                                                    : (isChangePassword)
                                                                    ? <Button
                                                                        type='submit'
                                                                        bsStyle='primary'
                                                                        style={{marginBottom: 15}}
                                                                        onClick={this.updateUserPassword}>
                                                                        Update Password
                                                                    </Button> :""
                                                                    // : <Button
                                                                    //     outlined
                                                                    //     type='submit'
                                                                    //     bsStyle='primary'
                                                                    //     style={{marginBottom: 15}}
                                                                    //     onClick={this.toggleEditInfo.bind(this, true)}>
                                                                    //     edit
                                                                    // </Button>
                                                            }
                                                            {
                                                                isEditable || isChangePassword ?
                                                                    <Button
                                                                        outlined
                                                                        type='button'
                                                                        bsStyle='primary'
                                                                        style={{marginLeft: 15, marginBottom: 15}}
                                                                        onClick={this.toggleEditInfo.bind(this, false)}>
                                                                        Cancel
                                                                    </Button> : null
                                                            }
                                                        </div>
                                                    </Col>
                                                </Tab.Pane>
                                            </Col>
                                        </Grid>
                                    </PanelBody>
                                </Panel>
                                    : null
                            }
                        </div>
                    </PanelBody>
                </Panel>
            </PanelContainer>
        )
    }
}

const
    mapStateToProps = state => ({
                                    user: {
                                        me: {
                                            isUpdated: isPasswordUpdated,
                                            updating,
                                            error: passwordError

                                        },
                                        specific: {userDetails = {}, error = undefined, fetching = false, isUserUpdate = false} = {}
                                    }
                                }) => {
        return {userInfo: userDetails, isUserUpdate, fetching, error, isPasswordUpdated, updating, passwordError}
    }

const
    mapDispatchToProps = dispatch => ({
        getUserInfo: (user) => {
            dispatch(UserActions.getSpecificUserRequest(user))
        },
        updatePassword: (password, newPassword) => {
            dispatch(UserActions.changePasswordRequest(
                password,
                newPassword
            ))
        },
        updateUserInfo: (id, name, email, image) => {
            dispatch(UserActions.updateSpecificUserRequest({
                id,
                name,
                email,
                image
            }))
        }
    })

export default connect(mapStateToProps, mapDispatchToProps)(AdminProfile)
